'use strict';

angular.module('shiftTraderApp')
  .factory('OrganizationMessageResponses', function (ServerUrls, $injector, Session, $q) {

    var $http = $injector.get('$http');

    //Notification model constructor
    var OrganizationMessageResponse = function(values) {
      var R = {};

      angular.extend(R, values);

      if (_.has(values, 'organization_message')) {
        var OrganizationMessages = $injector.get('OrganizationMessages');
        R.organization_message = OrganizationMessages.initWithData(values.organization_message);
      }

      if (!_.isNull(R.acknowledged_at)) {
        R.acknowledged_at = moment.utc(R.acknowledged_at).tz(Session.getTimezone());
        R._acknowledged_at_unix = R.acknowledged_at.unix();
      }

      if (!_.isNull(R.created_at)) {
        R.created_at = moment.utc(R.created_at).tz(Session.getTimezone());
      }

      if (!_.isNull(R.expires_at)) {
        R.expires_at = moment.utc(R.expires_at).tz(Session.getTimezone());
      }

      R.$clickedLinks = function(organizationMessage) {
        // look through organization_message for _discovered_links
        // order of links is in _discovered_links
        // URL of clicked_link is in R.metadata.clicked_links as keys

        var orgMessage = _.isUndefined(organizationMessage) ? R.organization_message : organizationMessage;

        if (R.metadata && R.metadata.link_clicks && !_.isEmpty(R.metadata.link_clicks)) {
          var res = [];

          _.each(_.keys(R.metadata.link_clicks), function(linkKey) {
            var messageLinkIndex = _.findIndex(orgMessage._discovered_links, {href: linkKey});
            if (messageLinkIndex > -1) {
              res.push(_.extend(orgMessage._discovered_links[messageLinkIndex], {
                visited_last_at: _.last(R.metadata.link_clicks[linkKey]),
                visits: R.metadata.link_clicks[linkKey],
                messageLinkIndex: messageLinkIndex,
                messageLinkNumber: messageLinkIndex + 1
              }));
            }
          });

          return res;
        } else {
          return null;
        }
      };

      R.$isAcknowledged = function() {
        return !_.isNull(R.acknowledged_at);
      };

      R.$sendAcknowledgement = function() {
        var that = this;
        var theTime = moment.utc().format();
        return $http.put(ServerUrls.current.railsApi + 'organization_message_responses/' + this.id, {
          acknowledged_at: theTime
        })
          .then(function() {
            that.acknowledged_at = moment.utc(theTime).tz(Session.getTimezone());
            return that;
          }, function(response) {
            return $q.reject(response);
          });
      };


      R.$trackLink = function(url) {
        var that = this;
        if (!R.metadata) {
          R.metadata = {
            link_clicks: {}
          };
        }

        if (!R.metadata.link_clicks[url]) {
          R.metadata.link_clicks[url] = []
        }

        R.metadata.link_clicks[url].push(moment.utc().toISOString());
        return $http.put(ServerUrls.current.railsApi + 'organization_message_responses/' + this.id, {
          metadata: R.metadata
        })
          .then(function(response) {
            that.metadata = response.data.metadata;
            return that;
          }, function(response) {
            return $q.reject(response);
          });
      };
      return R;
    };


    var OrganizationMessageResponses = {};

    OrganizationMessageResponses.getMyUnacknowledgedOrganizationMessageResponses = function () {
      return $http.get(ServerUrls.current.railsApi + 'organization_message_responses', {
        params: {
          user_id: 'me'
        }
      })
        .then(function (response) {
          return _.map(response.data, function (notfication) {
            return new OrganizationMessageResponse(notfication);
          });
        }, function(response) {
          console.log('OrganizationMessageResponse fetch failed');
          return $q.reject(response);
        });
    };

    OrganizationMessageResponses.getMyOrganizationMessageResponsesSince = function (dtString) {
      return $http.get(ServerUrls.current.railsApi + 'organization_message_responses',
        {
          params: {
            start_date: dtString,
            user_id: 'me'
          }
        })
        .then(function (response) {
          return _.map(response.data, function (organizationMessageResponses) {
            return new OrganizationMessageResponse(organizationMessageResponses);
          });
        }, function(response) {
          console.log('OrganizationMessageResponse fetch failed');
          return $q.reject(response);
        });
    };

    OrganizationMessageResponses.initWithData = function(data) {
      return new OrganizationMessageResponse(data);
    };

    return OrganizationMessageResponses;
  });
